<template>
  <div class="enterprise-apply-page">
    <h5 class="page-title">企业认证</h5>
    <div class="item">
      <div class="item-title">
        <span>*</span>
        <p>企业名称</p>
      </div>
      <div class="item-content">
        <el-input
          type="text"
          class="input"
          placeholder="请与营业执照保持一致"
          v-model="form.corporateName"
        >
        </el-input>
      </div>
      <div v-show="itemTips.corporateName" class="must-tip">
        <img
          src="../../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </div>
    </div>
    <div class="item">
      <div class="item-title">
        <span>*</span>
        <p>统一社会信用代码</p>
      </div>
      <div class="item-content">
        <el-input
          type="text"
          class="input"
          placeholder="请与营业执照保持一致"
          v-model="form.creditNo"
        >
        </el-input>
      </div>
      <div v-show="itemTips.creditNo" class="must-tip">
        <img
          src="../../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </div>
    </div>
    <div class="item photo-item">
      <div class="item-title">
        <span>*</span>
        <p>营业执照</p>
      </div>
      <div class="item-content photo-content">
        <p class="prompt-text">
          请上传小于5M，格式为jpg、png的图片，确保营业执照信息清晰可见
        </p>
        <div class="upload-box">
          <div
            v-if="!form.creditImageUrl"
            class="upload-btn"
            @click="clickUpload()"
          >
            <span>+</span>
            <p>上传图片</p>
          </div>
          <div
            v-else
            class="photo-show"
            :style="'background-image: url(' + form.creditImageUrl + ')'"
          >
            <div class="masking" @click="clickUpload()">修改</div>
          </div>
          <div class="reference-box">
            <span>参考图片</span>
            <img
              src="../../assets/images/shop-authentication/creditImage-default.png"
              alt=""
              class="reference-img"
            />
          </div>
          <div v-show="itemTips.creditImageUrl" class="must-tip">
            <img
              src="../../assets/images/must-tip-icon.png"
              alt=""
              class="must-tip-icon"
            />
            <span>必填项</span>
          </div>
          <!-- <p
            class="tips-text"
            :style="creditImageTips == '上传成功' ? 'color: #00FF7F' : ''"
            v-show="creditImageTips.length > 0"
          >
            {{ creditImageTips }}
          </p> -->
        </div>
        <input
          ref="photoFile"
          type="file"
          id="photo-file"
          @change="selectFile($event)"
          accept=".jpg,.png,.jpeg"
          style="display: none"
        />
      </div>
    </div>
    <div class="item">
      <div class="item-title">
        <span>*</span>
        <p>营业期限</p>
      </div>
      <div class="item-content">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          v-model="form.creditStartDate"
          @change="changeDate"
          value-format="yyyy-MM-dd"
          style="width: 202px"
        ></el-date-picker>
        至
        <el-date-picker
          type="date"
          placeholder="选择日期"
          :disabled="isLongTime"
          v-model="form.creditEndDate"
          @change="changeDate"
          value-format="yyyy-MM-dd"
          style="width: 202px"
        ></el-date-picker>
        <el-checkbox
          v-model="isLongTime"
          class="long-time"
          @change="changeLongTime()"
          >长期</el-checkbox
        >
      </div>
      <div
        v-show="itemTips.creditStartDate || itemTips.creditEndDate"
        class="must-tip"
      >
        <img
          src="../../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </div>
    </div>
    <div class="item">
      <div class="item-title">
        <span>*</span>
        <p v-show="!IsSelfEmployed">法人姓名</p>
        <p v-show="IsSelfEmployed">经营者姓名</p>
      </div>
      <div class="item-content">
        <el-input
          v-show="!IsSelfEmployed"
          type="text"
          class="input"
          placeholder="请输入法人姓名"
          v-model="form.legalName"
          maxlength="15"
        >
        </el-input>
        <el-input
          v-show="IsSelfEmployed"
          type="text"
          class="input"
          placeholder="请输入经营者姓名"
          v-model="form.legalName"
          maxlength="15"
        >
        </el-input>
      </div>
      <div v-show="itemTips.legalName" class="must-tip">
        <img
          src="../../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </div>
    </div>
    <div class="item">
      <div class="item-title">
        <span>*</span>
        <p v-show="!IsSelfEmployed">法人身份证号</p>
        <p v-show="IsSelfEmployed">经营者身份证号</p>
      </div>
      <div class="item-content">
        <el-input
          v-show="!IsSelfEmployed"
          type="text"
          class="input"
          placeholder="请输入法人身份证号"
          v-model="form.legalId"
          @change="changeLegalId()"
        >
        </el-input>
        <el-input
          v-show="IsSelfEmployed"
          type="text"
          class="input"
          placeholder="请输入经营者身份证号"
          v-model="form.legalId"
          @change="changeLegalId()"
        >
        </el-input>
        <p class="tips-text" v-show="legalTips.length > 0">{{ legalTips }}</p>
      </div>
      <div v-show="itemTips.legalId" class="must-tip">
        <img
          src="../../assets/images/must-tip-icon.png"
          alt=""
          class="must-tip-icon"
        />
        <span>必填项</span>
      </div>
    </div>
    <!-- 确定上传弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      top="calc(50vh -  102px)"
      width="400px"
      @close="closeDialog"
    >
      <p style="text-align: center">提交成功，请耐心等待审核结果~</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 底部通栏 -->
    <footer class="footer">
      <div class="cancel" @click="cancelUpload()">取消</div>
      <div class="sure" @click="uploadCheck()">提交</div>
    </footer>
  </div>
</template>

<script>
import api from "../../assets/js/api";
export default {
  name: "ShopCenterAdminWebEnterpriseApply",

  data() {
    return {
      form: {
        corporateName: "", // 企业名称
        creditNo: "", // 统一社会信用代码
        creditImageUrl: "", // 营业执照
        legalId: "", // 法人身份证
        legalName: "", // 法人名称
        creditStartDate: "", // 营业期限开始时间
        creditEndDate: "", // 营业期限结束时间
      },
      itemTips: {
        corporateName: false, // 企业名称
        creditNo: false, // 统一社会信用代码
        creditImageUrl: false, // 营业执照
        legalId: false, // 法人身份证
        legalName: false, // 法人名称
        creditStartDate: false, // 营业期限开始时间
        creditEndDate: false, // 营业期限结束时间
      },
      legalTips: "", // 身份证号校验提示
      creditImageTips: "", // 营业执照上传提示
      creditDate: "", // 营业期限
      photoFile: "", // 要上传的文件
      photoTypes: [
        // 允许的图片格式
        "jpg",
        "jpeg",
        "png",
      ],
      isSaved: false, // 是否为保存操作 决定是否触发beforeRouteLeave逻辑处理
      dialogVisible: false, // 控制弹窗变量
      isLongTime: false, // 营业执照是不是长期的
      hasApply: false, // 是否存在正在提交的请求
      IsSelfEmployed:
        this.$store.state.user.userInfo.shopTypeId == 90 ? true : false, //是否
    };
  },
  beforeRouteLeave(to, from, next) {
    // 如果保存操作后的跳转 直接跳转
    if (this.isSaved) {
      next();
    } else {
      this.$confirm("此时离开将丢失已编辑的内容，是否确认离开？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
          this.$store.commit(
            "setActiveIndex",
            "/authentication/shop-authentication"
          );
        });
    }
  },
  computed: {
    storeType() {
      // 店铺类型 1-个人 2-企业
      if (
        this.$store.state.user.userInfo.organizationTypeId == 1 ||
        (this.$store.state.user.userInfo.organizationTypeId == 2 &&
          this.$store.state.user.userInfo.shopTypeId == 65)
      ) {
        return 1;
      }
      return 2;
    },
  },
  async mounted() {
    // 个人店铺通过url强行访问 则跳回认证页面
    if (this.storeType == 1) {
      window.location.href =
        "https://shopcenter.xkw.com/authentication/shop-authentication";
    }
    // 只有未通过或者未认证的企业 才能访问该页面
    const status = await this.getIsEnterprise();
    if (status !== 0) {
      window.location.href =
        "https://shopcenter.xkw.com/authentication/shop-authentication";
    }
  },

  methods: {
    // 获取企业认证信息
    async getIsEnterprise() {
      let shopId = "";
      // 如果是运营人员
      if (this.$store.state.user.userInfo.userTypeId == 3) {
        shopId = this.$store.state.user.userInfo.shopId;
      }
      const res = await this.$axios.get(
        api.authentication.getIsEnterprise,
        {},
        {
          headers: {
            "shop-id": shopId,
          },
        }
      );
      // console.log("企业认证信息-----", res.result);
      this.authenticationInfo = res.result || {};
      // auditStatus 0-未认证，1-审核中，2-已认证
      return res.result.auditStatus || 0;
    },
    // 模拟点击上传
    clickUpload() {
      this.$refs.photoFile.click();
    },
    // 获取点击上传的文件
    selectFile(e) {
      this.photoFile = e.target.files[0];
      // console.log("获取到的文件---", this.photoFile);
      const typeArr = this.photoFile.type.split("/");
      if (typeArr[0] !== "image" || !this.photoTypes.includes(typeArr[1])) {
        this.$message.error("图片格式不正确，请重新选择~");
        return;
      } else if (this.photoFile.size > 1024 * 1024 * 5) {
        this.$message.error("图片文件大小不能超过5MB~");
        return;
      } else {
        // 这个地方开始上传图片
        this.uploadPhoto();
      }
    },
    // 上传图片
    async uploadPhoto() {
      // 上传图片
      const formDate = new FormData();
      formDate.append("file", this.photoFile);
      // 开启loading
      const loading = this.$loading({
        lock: true,
        customClass: "loading",
      });

      const res = await this.$axios.post(
        api.shopResource.uploadVideoIntroducePhoto,
        formDate
      );
      // console.log("上传图片的结果---", res);
      // 关闭loading
      loading.close();
      if (res.result.success) {
        this.$message.success("上传成功~");
        this.creditImageTips = "上传成功";
        this.form.creditImageUrl = res.result.filePath;
      } else {
        this.$message.error(res.error.message || "上传失败，请重试或联系客服~");
        this.creditImageTips = "上传失败";
      }
    },
    // 修改日期校验
    changeDate(e) {
      console.log(e);
    },
    // 营业执照选择长期
    changeLongTime() {
      if (this.isLongTime) {
        this.form.creditEndDate = "";
      }
    },
    // 校验身份证号
    changeLegalId() {
      const idCardReg = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/;
      if (!idCardReg.test(this.form.legalId) && this.form.legalId.length > 0) {
        this.legalTips = "身份证号格式不正确";
      } else {
        this.legalTips = "";
      }
    },
    // 取消提交
    cancelUpload() {
      this.isSaved = false;
      this.$router.push("/authentication/shop-authentication");
    },
    // 点击提交 进行校验
    async uploadCheck() {
      // 首先再次校验一下认证状态
      const status = await this.getIsEnterprise();
      if (status !== 0) {
        this.$message.warning("认证信息已提交，请耐心等待审核结果哦~");
        window.location.href =
          "https://shopcenter.xkw.com/authentication/shop-authentication";
        return;
      }
      // 检测是否全部填写 能进入下一步
      let isPass = true;
      const params = JSON.parse(JSON.stringify(this.form));
      // 如果营业执照是长期 则结束时间为2099-1-1
      if (this.isLongTime) {
        params.creditEndDate = "2099-01-01";
      }
      // 校验必填项
      for (let key in params) {
        if (!params[key] || params[key].toString().trim().length === 0) {
          this.itemTips[key] = true;
          isPass = false;
        } else {
          this.itemTips[key] = false;
        }
      }
      // 如果没有全部填写 则结束
      if (!isPass) return;
      // 如果全部填写则进入下一步
      this.sureUpload(params);
    },
    // 确定上传
    async sureUpload(params) {
      // 如果已经有正在提交的请求 则结束
      if (this.hasApply) return;
      // 否则开始提交请求 并进行标志
      this.hasApply = true;
      // 开启loading
      const loading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = "";
      // 测试环境需要写死图片
      // params.creditImageUrl =
      //   "https://materialresource.xkw.com/material/store/store_logo.png";
      // console.log("params----", params);
      try {
        res = await this.$axios.post(
          api.authentication.commitEnterpriseInfo,
          params
        );
        this.hasApply = false;
        // 关闭loading
        loading.close();
        // 请求成功 且 认证成功
        if (res.valid && res.result.data) {
          // 打开提示弹窗
          this.dialogVisible = true;
        }
        // 请求成功 但 认证失败
        else if (res.valid && !res.result.data) {
          this.$message.error(
            res.result.message || "上传失败，请重试或联系客服~"
          );
        } // 请求失败
        else {
          this.$message.error(
            res.error.message || "上传失败，请重试或联系客服~"
          );
        }
      } catch (error) {
        this.hasApply = false;
        // 关闭loading
        loading.close();
      }
    },
    // 提交成功后的弹窗被关闭时的提示
    closeDialog() {
      // 标志为保存操作 不触发beforeRouteLeave逻辑处理
      this.isSaved = true;
      // this.$router.push("/authentication/shop-authentication");
      window.location.href =
        "https://shopcenter.xkw.com/authentication/shop-authentication";
    },
  },
};
</script>

<style lang="scss" scoped>
.enterprise-apply-page {
  position: relative;
  height: calc(100% - 130px);
  min-height: 700px;
  min-width: 1200px;
  padding: 47px 0 0 60px;
  margin-bottom: 80px;
  border-radius: 5px;
  background: #fff;
  .page-title {
    margin-bottom: 30px;
    color: #3a3d4b;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 35px;
    .item-title {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 140px;
      margin-right: 20px;
      span {
        margin-right: 5px;
        color: #fe4509;
      }
      p {
        color: #333;
      }
    }
    .item-content {
      position: relative;
      .input {
        width: 500px;
      }
      .tips-text {
        position: absolute;
        bottom: -22px;
        left: 0;
        font-size: 12px;
        color: #fe4509;
      }
      .long-time {
        margin-left: 20px;
      }
    }
    .must-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;

      .must-tip-icon {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }

      span {
        font-size: 12px;
        color: #fe4509;
      }
    }
  }
  .photo-item {
    align-items: flex-start;
    .photo-content {
      .prompt-text {
        margin-bottom: 15px;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        color: #c4c8d0;
      }
      .upload-box {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .upload-btn {
          width: 128px;
          height: 94px;
          border: 1px dashed #a3baff;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          cursor: pointer;

          span {
            font-size: 20px;
            color: #5a83ff;
            text-align: center;
          }

          p {
            text-align: center;
            color: #5a83ff;
          }
          &:hover {
            opacity: 0.9;
          }
        }
        .photo-show {
          position: relative;
          width: 128px;
          height: 94px;
          border-radius: 5px;
          background-size: 100% 100%;
          .masking {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            color: #fff;
            font-size: 12px;
            background: rgba(0, 0, 0, 0.3);
            opacity: 0;
            border-radius: 5px;
            transition: all 0.3s linear;
          }
          &:hover {
            .masking {
              opacity: 1;
              cursor: pointer;
            }
          }
        }
        .reference-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 128px;
          height: 94px;
          margin-left: 20px;
          background: rgba(245, 247, 250);
          border: 1px solid #ccc;
          border-radius: 5px;
          span {
            font-size: 12px;
            color: #c4c8d0;
          }
          .reference-img {
            width: 90px;
            height: auto;
            margin-top: 5px;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    // bottom: -20px;
    // right: -20px;
    bottom: 0px;
    right: 0px;
    z-index: 2;
    width: calc(100% + 40px);
    height: 70px;
    background-color: #fff;

    .cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      margin-right: 60px;
      transform: translateX(120px);
      background: #ffffff;
      border: 1px solid #dddfe6;
      border-radius: 3px;
      color: #606266;
      cursor: pointer;
    }
    .sure {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      transform: translateX(120px);
      color: #fff;
      background: #5a83ff;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
